import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useUserStore } from '@/stores/user'

/**
 * Guard para proteger rutas que requieren autenticación
 */
export function requireAuth(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const userStore = useUserStore()
  
  // Verificar autenticación
  if (!userStore.isAuthenticated) {
    // Guardar la ruta a la que intentaba acceder para redirigir después del login
    next({
      name: 'home',
      query: { redirect: to.fullPath }
    })
    return
  }
  
  if (!userStore.ensureValidToken()) {
    next({
      name: 'home',
      query: { redirect: to.fullPath, expired: 'true' }
    })
    return
  }
  
  next()
}

/**
 * Guard para proteger rutas que requieren rol de administrador
 * Solo usuarios con Role_id === 1 pueden acceder
 */
export function requireAdmin(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const userStore = useUserStore()
  
  // Primero verificar autenticación
  if (!userStore.isAuthenticated) {
    next({
      name: 'home',
      query: { redirect: to.fullPath }
    })
    return
  }
  
  if (!userStore.ensureValidToken()) {
    next({
      name: 'home',
      query: { redirect: to.fullPath, expired: 'true' }
    })
    return
  }
  
  // Verificar que el usuario sea admin (Role_id === 1)
  if (!userStore.isAdmin) {
    // Usuario autenticado pero NO es admin (Role_id !== 1)
    // Log de seguridad (en producción, enviar a un servicio de logging)
    next({
      name: 'home'
    })
    return
  }
  
  // Usuario autenticado, token válido y es admin
  next()
}

/**
 * Guard para redirigir usuarios autenticados (ej: si ya está logueado, no puede ver login)
 */
export function guestOnly(
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const userStore = useUserStore()
  
  if (userStore.isAuthenticated) {
    next({ name: 'home' })
  } else {
    next()
  }
}

